import { makeTraceDetails } from 'common'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'
import { useAppContext } from 'contexts/app-context/hooks'
import { isEmpty } from 'lodash'
import { Routes } from 'common/constants'

function useManageNotifications() {
  const { privacyCenterContent, userCountry, userSelectedEntity } = useAppContext()

  const content = privacyCenterContent?.components?.manageNotifications?.content
  const isActive = !!privacyCenterContent?.components?.manageNotifications?.isActive

  const isError = isEmpty(content)

  const descriptionSection =
    userCountry === 'BR' && content
      ? content.productsSection.productMenu.TODOS_OS_PRODUTOS
      : undefined

  const title = content?.title

  const alertSection = content?.alertSection

  const doNotDisturbSection = content?.doNotDisturbSection

  const headerSection = content?.headerSection

  const productsSection = content?.productsSection

  const traceDetails = makeTraceDetails(isActive, content)

  useScreenFinishLoadTac({
    name: 'ManageNotifications',
    screen: Routes.NOTIFICATIONS_MANAGEMENT,
    action: 'ManageNotificationsFinishLoad',
    entity: userSelectedEntity,
    shouldSend: !isError && isActive && !!content,
    logLabel: 'send manage notifications finish tac',
  })

  return {
    isError,
    descriptionSection,
    title,
    alertSection,
    doNotDisturbSection,
    headerSection,
    productsSection,
    userCountry,
    traceDetails,
  }
}

export { useManageNotifications }
